import { useRouter } from "next/router";
import cn from "classnames";
import {
  PostType,
  PostCategoryCountType,
  useWindowDimensions,
} from "@ascendnow/shared";
import { AscDropdown } from "@ascendnow/ascend-components";

import styles from "./AscPostCategoryList.module.scss";
import { useState } from "react";

const categoryTitles = {
  [PostType.ALLPOSTS]: "All Posts",
  [PostType.COMPETITIONS]: "Competitions",
  [PostType.CONTENT]: "Content changes",
  [PostType.GENERAL]: "General updates",
  [PostType.PLATFORM]: "Platform Updates",
  [PostType.WEBINARS]: "Upcoming webinars",
};

export const AscPostCategoryList = ({
  count,
  pathname,
}: {
  count: PostCategoryCountType;
  pathname?: string;
}) => {
  const router = useRouter();
  const { width } = useWindowDimensions();
  const postCategoryList = Object.keys(count).sort() as PostType[];

  return width < 992 ? (
    <AscDropdown
      title={
        categoryTitles[
          router.query.category
            ? (router.query.category as PostType)
            : PostType.ALLPOSTS
        ]
      }
      className={styles.mobileDropdown}
      titleContainerClassName={styles.mobileDropdownTitleContainer}
      fullWidth
    >
      {postCategoryList?.map((el) => (
        <AscDropdown.Option
          key={el}
          onClick={() => {
            if (pathname) {
              router.pathname = pathname;
            }
            router.query.category = el;
            router.push(router);
          }}
        >
          {categoryTitles[el]}
        </AscDropdown.Option>
      ))}
    </AscDropdown>
  ) : (
    <nav className={styles.postCategoryWrapper}>
      <ul className={styles.postCategoryList}>
        {postCategoryList.map((el) => (
          <li
            key={el}
            className={cn(
              styles.postCategory,
              router.query.category === el && styles["postCategory--active"]
            )}
            onClick={() => {
              if (pathname) {
                router.pathname = pathname;
              }
              router.query.category = el;
              router.push(router);
            }}
          >
            {categoryTitles[el]}{" "}
            <span className={styles.postCategoryTotalPosts}>{count[el]}</span>
          </li>
        ))}
      </ul>
    </nav>
  );
};
